import React from "react";
import { Zap } from "lucide-react";
import type { ExchangeHighlight as ExchangeHighlightCopy } from "@/utils/exchange-config";

interface ExchangeHighlightProps {
  highlight: ExchangeHighlightCopy;
  compact?: boolean;
}

/**
 * Accent callout at the top of the connect flow for exchanges whose key
 * brings a benefit worth stating up front (Upbit: faster alerts).
 */
export const ExchangeHighlight: React.FC<ExchangeHighlightProps> = ({
  highlight,
  compact = false,
}) => (
  <div className="bg-accent/10 border border-accent/30 rounded-lg p-4 space-y-1">
    <div className="flex items-center gap-2">
      <Zap className="w-5 h-5 text-accent shrink-0" />
      <h4 className="font-semibold text-text-primary">{highlight.title}</h4>
    </div>
    {!compact && (
      <p className="text-sm text-text-secondary leading-relaxed">{highlight.text}</p>
    )}
    {compact && (
      <p className="text-xs text-text-secondary leading-relaxed">{highlight.text}</p>
    )}
  </div>
);
